/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import PropTypes from 'prop-types';

import { Formik, Form } from 'formik';
import Button from '@material-ui/core/Button';
import { MuiThemeProvider } from '@material-ui/core/styles';

import { theme } from '../../../Theme/theme';
import MetaField from '../../../Components/MetaField/MetaField';

const EditInfos = ({ id, fields, initialValues, buttonSubmitLabel, updateParty, setViewMode, locale }) => (
  <Formik
    initialValues={initialValues}
    onSubmit={(values, { setSubmitting }) => {
      updateParty({ id, payload: values });
      setSubmitting(false);
      setViewMode();
    }}
    // eslint-disable-next-line no-console
    validate={values => console.log(values ? '' : '')}
    render={({ values, errors, touched, isSubmitting }) => (
      <Form autoComplete="new-form" className="formik-form">
        {fields.map(field => (
          <MetaField
            key={`field-${field.name}`}
            name={field.name}
            value={values[field.name] || ''}
            label={field.label}
            type={field.type}
            options={field.options}
            errors={errors}
            touched={touched}
            autoComplete="off"
            locale={locale}
          />
        ))}
        <div className="block-actions">
          <MuiThemeProvider theme={theme}>
            <Button type="submit" variant="contained" color="primary" disabled={isSubmitting}>
              {buttonSubmitLabel || 'Submit'}
            </Button>
          </MuiThemeProvider>
        </div>
      </Form>
    )}
  />
);

const model = PropTypes.shape({
  firstname: PropTypes.string,
  name: PropTypes.string,
  age: PropTypes.number,
});

const personalInfos = PropTypes.arrayOf(model);

const option = PropTypes.shape({
  value: PropTypes.string.isRequired,
  text: PropTypes.string,
  label: PropTypes.string,
});

EditInfos.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string,
      placeholder: PropTypes.string,
      type: PropTypes.oneOf(['string', 'number', 'date', 'selection']),
      options: PropTypes.arrayOf(option),
    })
  ),
  initialValues: PropTypes.shape({ personalInfos }),
  buttonSubmitLabel: PropTypes.string,
  updateParty: PropTypes.func.isRequired,
  setViewMode: PropTypes.func.isRequired,
  locale: PropTypes.string,
};

EditInfos.defaultProps = {
  fields: [
    {
      name: 'gender',
      type: 'selection',
      label: 'Gender',
      options: [
        { value: 'male', text: 'M.', label: 'M.' },
        { value: 'female', text: 'Mme.', label: 'Mme.' },
        { value: '', text: '', label: '' },
      ],
    },
    { name: 'firstname', type: 'string', label: 'Firstname' },
    { name: 'name', type: 'string', label: 'Name' },
    { name: 'age', type: 'number', label: 'Age' },
  ],
  initialValues: { firstname: 'jason', name: 'tuche', age: 20 },
  buttonSubmitLabel: undefined,
  locale: 'fr',
};

export default EditInfos;
